const CONSTANT = {
  SESSION_CREDENTIALS: 'Session-Credentials'
}

export {
  CONSTANT
}